import React from 'react';
import { SectionProps } from '../types';
import classnames from 'classnames';
import { CheckSquareFilled, TruckOutlined } from '@ant-design/icons';
import { SidebarSectionEnum } from '../enums';

const Catering = ({ data, ...rest }: SectionProps) => {
  const cateringLabel = data.has_catering
    ? `Yes${data.catering_min_people ? ` (from ${data.catering_min_people} persons)` : ''}`
    : 'No';

  return (
    <section {...rest} id={SidebarSectionEnum.Catering}>
      <h4 className="text-md font-semibold text-slate-700">
        <TruckOutlined className="mr-2 size-4" />
        Catering
      </h4>
      <div className="flex justify-between text-slate-600">
        <p className="text-sm">Catering available</p>
        <p
          className={classnames('text-sm font-medium', {
            'px-[10px] py-[2px] bg-green-500/10 rounded-lg text-green-500 hover:bg-slate-700/80':
              data.has_catering,
          })}
        >
          {data.has_catering && <CheckSquareFilled className="mr-1" />}
          {cateringLabel}
        </p>
      </div>
      {data.has_catering && (
        <p className="text-xs text-slate-600 bg-gray-200/30 p-3 rounded-lg">
          <strong>Catering inquiries: </strong>We would be pleased to connect you with the owner or
          kindly request that you send an email with the subject line &#34;Catering&#34; to{' '}
          <strong>{data.contacts.email}</strong>.
        </p>
      )}
    </section>
  );
};

export default Catering;
